import { Runtime } from "fp";
import { Remote } from "~/Remote";
import { Time } from "~/Time";

import * as Request from "./Request";

export type RevisionStatusType = {
  readonly canRevise: boolean,
  readonly timeIsPermalocked: boolean,
  readonly approvalSetting: string,
  readonly timeIsInCurrentReportingPeriod: boolean,
  readonly approvalStatus: string,
  readonly revisionStatusMessage: string,
};

export namespace RevisionStatus {
  export namespace Data {
    export const use = (driverId: string, startDate: string): Remote<RevisionStatusType> => {
      const status = Remote.Query.use<RevisionStatusType>(
        Request.Query.key(driverId, startDate),
        Request.Query.request(driverId, startDate),
        {
          keepPreviousData: true,
          staleTime: Time.Duration.minutes(60).duration,
        }
      );

      return status;
    };

    export const useWhenAvailable = (driverId: string, startDate: string): RevisionStatusType | undefined =>
      pipe(use(driverId, startDate), Remote.toUndefined);
  }

  export namespace Response {
    export const runtime = () =>
      Runtime.strict({
        can_revise: Runtime.boolean(),
        time_is_permalocked: Runtime.boolean(),
        approval_setting: Runtime.string(),
        time_is_in_current_reporting_period: Runtime.boolean(),
        approval_status: Runtime.string(),
        revision_status_type: Runtime.number(),
      });

    export const decode = (
      response: Runtime.ToType<typeof runtime>
    ): RevisionStatusType => ({
      canRevise: response.can_revise,
      timeIsPermalocked: response.time_is_permalocked,
      approvalSetting: response.approval_setting, 
      timeIsInCurrentReportingPeriod: response.time_is_in_current_reporting_period,
      approvalStatus: response.approval_status,
      revisionStatusMessage: mapStatusTypeToMessage(response.revision_status_type),
    });
  }
}

function mapStatusTypeToMessage(revision_status_type: number): string {
  switch (revision_status_type) {
    case 1:
      return "This log is in a Time Cards Locked pay period. Revisions and edits made to this log will only be available in E-Logs and not reflected in Time Cards.";
    case 2:
      return "This Time Cards timesheet has been Approved. Revisions and edits made to this log will only be available in E-Logs and not reflected in Time Cards.";
    case 3:
      return "This Time Cards timesheet is Approved. Revisions and edits made to this log will change timesheet status to Unapproved.";
    case 4:
      return "";
    default:
      return "";
  }
}

